import AvatarIcon from '../../../../assets/medium_default_optimized.png';

export const formatTwigs = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);
};

export const getDisplayName = (notification) => {
  const firstName = notification?.senderFirstName || notification?.firstName;
  const lastName = notification?.senderLastName || notification?.lastName;
  const fullName = notification?.senderName || notification?.fullName;
  const username = notification?.senderUsername || notification?.username;

  if (fullName) return fullName;
  if (firstName && lastName) return `${firstName} ${lastName}`;
  if (firstName) return firstName;
  if (lastName) return lastName;
  if (username) return username;
  return 'System';
};

export const getAvatarSrc = (notification, fallbackAvatar) => {
  return notification?.senderAvatarUrl || notification?.avatarUrl || fallbackAvatar;
};

export interface IMetadata {
  articleTitle?: string;
  commentText?: string;
  twigsAmount?: number;
  contentType?: string;
  reason?: string;
  avatar?: string;
  firstName?: string;
  lastName?: string;
  reactionType?: string;
  username?: string;
  description?: string;
  requestTitle?: string;
  responseTitle?: string;
  responseType?: string;
  articleViewNumber?: number;
  articleReactionNumber?: number;
  articleCommentNumber?: number;
  articleMilestone?: number;
  [key: string]: any;
}

export const getMeta = (notification): IMetadata => {
  const meta = notification?.metadata || {};

  return {
    ...meta,
    articleTitle: meta.articleTitle,
    commentText: meta.comment,
    twigsAmount: meta.twigsAmount ?? meta.twigs,
    contentType: meta.contentType,
    reason: meta.reason,
    avatar: meta.avatar || AvatarIcon,
    firstName: meta.firstName,
    lastName: meta.lastName,
    username: meta.username,
    reactionType: meta.reactionType,
    description: meta.description,
    requestTitle: meta.requestTitle,
    responseTitle: meta.responseTitle,
    responseType: meta.responseType,
    articleViewNumber: meta.articleViewNumber,
    articleReactionNumber: meta.articleReactionNumber,
    articleCommentNumber: meta.articleCommentNumber,
    articleMilestone: meta.articleMilestone
  };
};

export const formatCommentText = (text: unknown, maxLength = 49): string | null => {
  if (text == null) return null;
  const str = String(text).trim();
  if (!str) return null;
  if (str.length <= maxLength) return str;
  const ellipsis = '...';
  const sliceLen = Math.max(0, maxLength - ellipsis.length);
  return `${str.slice(0, sliceLen)}${ellipsis}`;
};
